var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_6271_192947)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 14.5C24.6647 14.5 25 14.1648 25 13.75V10C25 9.58525 24.6647 9.25 24.25 9.25H7.75C7.33525 9.25 7 9.58525 7 10V13.75C7 14.1648 7.33525 14.5 7.75 14.5C8.57725 14.5 9.25 15.1727 9.25 16C9.25 16.8273 8.57725 17.5 7.75 17.5C7.33525 17.5 7 17.8352 7 18.25V22C7 22.4148 7.33525 22.75 7.75 22.75H24.25C24.6647 22.75 25 22.4148 25 22V18.25C25 17.8352 24.6647 17.5 24.25 17.5C23.4228 17.5 22.75 16.8273 22.75 16C22.75 15.1727 23.4228 14.5 24.25 14.5ZM19.75 18.25H12.25V16.75H19.75V18.25ZM19.75 15.25H12.25V13.75H19.75V15.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6271_192947",
    x1: -1.58138e-9,
    y1: 16,
    x2: 31.9457,
    y2: 15.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivine);
export default __webpack_public_path__ + "static/media/divine.7663d72fd42b59d2784f8dc57d7ed4af.svg";
export { ForwardRef as ReactComponent };